import type { ExperienceEvent } from '@atlassian/experience-tracker';

import type { Experience } from './index';

export const collectAllWithSubExperienceAttributes = (
	subExperiences: string[],
	additionalAttributes?: Record<string, unknown>,
) => {
	const subExperienceNameSet = new Set(subExperiences);
	const mergedAttributes = {};
	return (events: ExperienceEvent[], experience: Experience): void => {
		// all subExperiences must succeed for the parent experience to succeed
		// a failure/abort to any subExperience will fail/abort the parent experience
		events.forEach((event) => {
			if (subExperienceNameSet.has(event.name)) {
				switch (event.action) {
					case 'taskSuccess':
						if (subExperienceNameSet.delete(event.name)) {
							Object.assign(mergedAttributes, event.attributes ?? {});
						}
						break;
					case 'taskFail':
						if ('error' in event) {
							experience.fail({
								error: event.error,
								attributes: { ...additionalAttributes, ...event.attributes },
							});
						}
						break;
					case 'taskAbort':
						experience.abort({
							reason: `${event.name} aborted`,
							attributes: {
								...additionalAttributes,
								...event.attributes,
								childAbortReason: event.reason,
							},
						});
						break;
				}
			}
		});

		if (subExperienceNameSet.size === 0) {
			experience.succeed({ ...additionalAttributes, ...mergedAttributes });
		}
	};
};
